import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"fingerprint-3"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M3 13V11C3 6.02944 7.02944 2 12 2C13.3369 2 14.6057 2.29148 15.7463 2.81436M19.4965 21.0001C20.4623 18.8654 21 16.4955 21 14.0001V11.0001C21 8.77009 20.1889 6.7295 18.8457 5.15723M8.42713 8.26367C7.84562 9.02187 7.5 9.9705 7.5 10.9999V11.9999M16.5 11C16.5 8.51472 14.4853 6.5 12 6.5M3 17.4999H4C5.27316 17.4999 6.38755 16.8201 7 15.8037M14.3579 21C15.5348 19.262 16.2857 17.212 16.4608 15M12 11V14C12 17.012 10.3354 19.6353 7.87598 21","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Fingerprint3 = Vue.extend<IconProps>({
  name: 'Fingerprint3Icon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'fingerprint-3',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default Fingerprint3;
